import React, { useEffect, useState } from 'react';
import api, { setAuthToken } from '../services/api';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { RecentGames } from '../components/RecentGames';
import { ProviderCarousel } from '../components/ProviderCarousel';

interface Game {
  id: string;
  name: string;
  category: string;
  external_id: string;
  thumbnail: string;
  provider_name: string;
  provider_slug: string;
  provider_api_url: string;
}

export function GameLobby() {
  const [groupedGames, setGroupedGames] = useState<{ [key: string]: Game[] }>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const fetchGames = async () => {
      if (!isAuthenticated) {
        setLoading(false);
        setError("Você precisa estar logado para ver os jogos.");
        return;
      }

      try {
        const response = await api.get('/games/catalog');

        if (response.data.success) {
          const grouped = response.data.games.reduce((acc: { [key: string]: Game[] }, game: Game) => {
            const provider = game.provider_name;
            if (!acc[provider]) {
              acc[provider] = [];
            }
            acc[provider].push(game);
            return acc;
          }, {});
          setGroupedGames(grouped);
        } else {
          setError(response.data.error || 'Erro ao carregar jogos.');
        }
      } catch (err) {
        setError('Erro ao conectar com o servidor de jogos.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, [isAuthenticated]);

  if (loading) {
    return <div className="text-center text-gray-600">Carregando jogos...</div>;
  }

  if (error) {
    return <div className="text-center text-red-600">Erro: {error}</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <RecentGames />
      <h1 className="text-3xl font-bold text-center text-white-800 my-8">Lobby de Jogos</h1>
      
      {Object.keys(groupedGames).map(providerName => (
        <ProviderCarousel 
          key={providerName} 
          providerName={providerName} 
          games={groupedGames[providerName]} 
        />
      ))}
    </div>
  );
}